// import './Member.css';
import { useMemo, useState } from 'react';
import 'react-tooltip/dist/react-tooltip.css'
import { useEffect } from 'react';
import { Tooltip as ReactTooltip } from "react-tooltip";
import { toast } from 'react-toastify';
import httpClient from '../../HTTPService';
import moment from 'moment';
import { useLocation, useNavigate, useParams } from 'react-router-dom';
// import DynamicTooltip from './CustomTooltip';
// import TooltipManager from './CustomTooltip';
const ApprovedProfile = () => {
    const params = useParams();
    let { filters } = params
    const [offsetValue, setoffsetValue] = useState(0);
    const [memberlist, setmemberlist] = useState([]);
    const [originalMemberList, setOriginalMemberList] = useState([])
    const navigate = useNavigate();
    const [searchtext, setsearchtext] = useState('')
    const [totalCount, setTotalCount] = useState(0)
    const [currentPage, setCurrentPage] = useState(1);
    const [getLimit, setLimit] = useState(10);
    const items = Array.from({ length: totalCount }, (_, index) => `Item ${index + 1}`);
    const itemsPerPage = 10;
    const totalPages = Math.ceil(items.length / getLimit);
    const startPage = Math.max(1, currentPage - Math.floor(5 / 2));
    const endPage = Math.min(totalPages, currentPage + Math.floor(5 / 2));
    const [filter, setfilter] = useState(null)
    let location = useLocation()
    const [setChange, setLimitChange] = useState(false)
    const [memberDetailsLoading, setMemberDetailsLoading] = useState(false)

    const [revenueList, setRevenueList] = useState([])
    const [currentmemberdetails, setCurrentmemberdetails] = useState({})

    const handlePageChange = (page) => {
        setCurrentPage(page);
        // location  = undefined
    };

    const [filterblock, setfilterblock] = useState(null)

    const startIndex = (currentPage - 1) * getLimit;
    const currentItems = items.slice(startIndex, startIndex + getLimit);

    //pagination
    const Pagination = ({ currentPage, totalPages, onPageChange }) => {
        const pages = [];
        for (let i = 1; i <= totalPages; i++) {
            pages.push(i);
        }
        console.log(currentPage, 'current pages...')
        return (
            <div className="pagination">
                {currentPage > 1 && (
                    <button className="pagination-btn" onClick={() => onPageChange(currentPage - 1)}>
                        <i className="fa fa-chevron-left" aria-hidden="true"></i>
                    </button>
                )}
                {startPage > 1 && (
                    <button className="pagination-btn" onClick={() => onPageChange(1)}>
                        1
                    </button>
                )}
                {startPage > 2 && <span className="pagination-ellipsis">...</span>}
                {pages.slice(startPage - 1, endPage).map(page => (
                    <button
                        key={page}
                        className={`pagination-btn ${page === currentPage ? 'active' : ''}`}
                        onClick={() => onPageChange(page)}
                    >
                        {page}
                    </button>
                ))}
                {endPage < totalPages - 1 && <span className="pagination-ellipsis">...</span>}
                {endPage < totalPages && (
                    <button className="pagination-btn" onClick={() => onPageChange(totalPages)}>
                        {totalPages}
                    </button>
                )}
                {currentPage < totalPages && (
                    <button className="pagination-btn" onClick={() => onPageChange(currentPage + 1)}>
                        <i className="fa fa-chevron-right" aria-hidden="true"></i>
                    </button>
                )}
            </div>
        );
    };

    useEffect(() => {

        // console.log(filters, location?.state, 'locaton data....//?')
        // if (location?.state?.backpagi == undefined) {
        //     if (filters == 'paid') {
        //         console.log('paiddddd')
        //         getMembers3(searchtext, currentPage, getLimit)

        //     } else {
        console.log('normal////')
        // setCurrentPage(1)
        getMembers(searchtext, currentPage, getLimit)

        // }
        // getMembers();
        // } else if (location?.state?.backpagi != undefined) {
        //     //    console.log('fkjsdfjskfjskfjsklfjskf')
        //     setCurrentPage(location?.state?.backpagi?.pageCurrent)
        //     setLimit(location?.state?.backpagi?.limit)
        //     if (filters == 'paid') {
        //         console.log('paiddddd')
        //         getMembers3(searchtext, location?.state?.backpagi?.pageCurrent, location?.state?.backpagi?.limit)

        //     } else {
        //         console.log('normal////')
        //         getMembers(searchtext, location?.state?.backpagi?.pageCurrent, location?.state?.backpagi?.limit)

        //     }
        // }

    }, [currentPage, getLimit, filter, filters]);
    const editItem = (e) => {
        // console.log(e);
        let paginationState = {
            pageCurrent: currentPage,
            limit: getLimit,

        }
        navigate(`/memberprofile-details?id=${e?.id}`, {
            state: {
                paginationState
            }
        });
        //  localStorage.setItem('editSubData',editSub)
    }
    const viewIncome = (e) => {
        let paginationState = {
            pageCurrent: currentPage,
            limit: getLimit,

        }
        navigate(`/memberincome?id=${e?.id}/:income`,
            {
                state: {
                    paginationState
                }
            }

        );
        //  localStorage.setItem('editSubData',editSub)
    }
    const viewTeam = (e) => {
        console.log(e);
        let paginationState = {
            pageCurrent: currentPage,
            limit: getLimit,

        }
        // const editSub = JSON.stringify(e)
        navigate(`/member-teamdetails?id=${e?.id}`,

            {
                state: {
                    paginationState
                }
            }
        );
        //  localStorage.setItem('editSubData',editSub)
    }
    const searchtxt = () => {
        getMembers(searchtext, 1, getLimit);
    }

    // view tooltip
    function setTooltipMessage(message) {
        const tooltipBox = document.getElementById('tooltipBox');
        tooltipBox.textContent = message;
    }
    const getMembers = async (search_name, pagecount, limit) => {
        try {
            const result = await httpClient.post('/admin/members-approved-profile-list', {
                search_name,
                offset: pagecount, limit: limit,
                search_status: filter,
                // search_keyword: search_name,
                // search_status:filter,
                // search_membership_type: filters == 'blocked' ? 0 : filters == 'unpaid' ? 3 : filters == 'paid' ? 4 : filter,
                // search_is_blocked:filterblock
            }, {
                headers: {
                    "Content-Type": "application/json",
                    "Accept": "application/json",
                    'Authorization': `Bearer ${localStorage.getItem('token')}`
                }
            })

            if (result.status === 200) {
                // location?.state = ''
                // console.log(result.data.data, 'data..')
                // location.state = null
                setTotalCount(result?.data.total_count)
                console.log(result?.data?.data, 'member sli sere')
                setmemberlist(result?.data?.data)
                setChange(false)
            }

        } catch (error) {
            //   toast.error(error.message)
        }
    }
    const getMembers3 = async (search_name, pagecount, limit) => {
        try {
            const result = await httpClient.post('/admin/member-list', {
                search_name,
                offset: pagecount, limit: limit,
                // search_status:filter,
                search_membership_type: filter,
                // search_is_blocked:filterblock
            }, {
                headers: {
                    "Content-Type": "application/json",
                    "Accept": "application/json",
                    'Authorization': `Bearer ${localStorage.getItem('token')}`
                }
            })

            if (result.status === 200) {
                // location?.state = ''
                // console.log(result.data.data, 'data..')
                // location.state = null
                setTotalCount(result?.data.total_count)
                console.log(result?.data?.data, 'member sli sere')
                setmemberlist(result?.data?.data)
                setChange(false)
            }

        } catch (error) {
            //   toast.error(error.message)
        }
    }

    // filterd data
    useMemo(() => {
        console.log(filter, 'filterd...')

        // if (filter != 3) {
        //     let _filterdata = [...originalMemberList].filter(_fitem => _fitem.active == filter)
        //     console.log(_filterdata, filter, 'filted data..')
        //     setmemberlist(_filterdata)
        // } else if (filter == 3) {
        // //     console.log('set orginal')
        //     setmemberlist(originalMemberList)
        // }
        // getMembers()

        return () => { }

    }, [])


    // debounce function to limit the number of API calss
    function debounce(func, delay) {
        let timeout;
        return (...args) => {
            clearTimeout(timeout);
            timeout = setTimeout(() => func(...args), delay);
        };
    }
    // search handler function
    const searchHandler = debounce((query) => {
        setsearchtext(query);
        getMembers(query, 1, getLimit);
    }, 2000)

    // Get renue list

    const getRevenueList = async (id) => {
        setMemberDetailsLoading(true)
        try {
            const result = await httpClient.post('/admin/profile-renue-list', {
                business_account_id: id
            }, {
                headers: {
                    "Content-Type": "application/json",
                    "Accept": "application/json",
                    'Authorization': `Bearer ${localStorage.getItem('token')}`
                }
            })

            if (result.status === 200) {

                console.log('retretert', result)
                setRevenueList(result?.data?.data)
                setMemberDetailsLoading(false)
            }

        } catch (error) {
            //   toast.error(error.message)
        }
    }
    return (
        <div className="member">

            <div className=''>

                <div className="search-box" >
                    {/* {
                        filters == 'paid' && ( */}
                    <div class="searchtct " style={{
                        paddingRight: 20
                    }}>

                        <i class="fa fa-filter" aria-hidden="true"></i>
                        <select
                            value={filter}
                            // className='ml-3'
                            // disabled={chooseFldType ===     '' ? true : false}
                            onChange={(val) => {
                                // if (val.target.value == 1 || val.target.value == 2 || val.target.value == null) {
                                // navigate('/member/paid')
                                setfilter(val.target.value)
                                // } else {
                                //     setfilter(val.target.value)

                                // }

                            }}
                        //   className={(isrequired && labelvalue === null) ? 'required' :'' }
                        >
                            <option value={null} >All</option>
                            <option value={1}>Lived</option>
                            <option value={2}>Blocked</option>
                            <option value={3}>Disabled</option>
                            <option value={4}>Expired</option>
                            <option value={5}>Renewal</option>

                        </select>

                    </div>
                    {/* )
                    } */}

                    {/* {
                        filters == 'all' && (
                            <div class="searchtct " style={{
                                paddingRight: 20
                            }}>

                                <i class="fa fa-filter" aria-hidden="true"></i>
                                <select
                                    value={filter}
                                    // className='ml-3'
                                    // disabled={chooseFldType ===     '' ? true : false}
                                    onChange={(val) => {
                                        if (val.target.value == null) {
                                            navigate('/member/all')
                                            setfilter(val.target.value)
                                        } else {
                                            setfilter(val.target.value)

                                        }

                                    }}
                                //   className={(isrequired && labelvalue === null) ? 'required' :'' }
                                >
                                    <option value={null} >All Member</option>
                                    <option value={4}>Paid </option>
                                    <option value={3}>Unpaid </option>
                                    <option value={0}>Block</option>
                                    <option value={5}>Deleted </option>


                                </select>

                            </div>
                        )
                    } */}
                    <div class="searchtct">

                        <i class="fa fa-search" aria-hidden="true"></i>
                        <input type="text" name="text" placeholder="Search..."
                            onChange={(val) => searchHandler(val.target.value, currentPage, getLimit)}

                        />
                        {/* <button type='button' className='searchBtn' onClick={searchtxt} >Search</button> */}


                    </div>

                </div>
            </div>

            <h4>
                {
                    filter == 1 ? `Total Lived Profiles: ${totalCount}` :
                        filter == 2 ? `Total Blocked Profiles: ${totalCount}` :
                            filter == 3 ? `Total Disabled Profiles: ${totalCount}` :
                                filter == 4 ? `Total Expired Profiles: ${totalCount}` :
                                    `Total Approved Profiles: ${totalCount}`
                }
                {/* {
                location?.state?.unpaid != undefined ?  :
                    location?.state?.paid != undefined ? `Total Paid Member: ${totalCount}` : `Total Member: ${totalCount}`
            }
             */}
            </h4>
            <div class="row">
                <div class="col-md-12">
                    <div class="table-responsive">
                        <table class="table">
                            <thead>
                                <tr>
                                    <th>SL NO</th>
                                    <th>Member Name & ID</th>
                                    <th>Categoty</th>
                                    <th>Sub Categoty</th>
                                    <th>Buying Plan</th>
                                    <th>Pay Amount</th>
                                    <th>Buying Date</th>
                                    <th>Approved Date</th>
                                    <th>Status</th>
                                    {/* <th>View Details</th> */}

                                </tr>
                            </thead>
                            <tbody>

                                {
                                    memberlist?.map((item, index) => {
                                        const serialNumber = (currentPage - 1) * getLimit + index + 1;

                                        return (
                                            <>
                                                <tr >
                                                    <td
                                                        style={{


                                                        }}
                                                    >{serialNumber}</td>
                                                    <td style={{


                                                    }}>
                                                        <div style={{
                                                            display: 'flex',
                                                            flexDirection: 'column'
                                                        }}>
                                                            <p>{item?.member_name} </p>
                                                            <p> {item?.member_code}</p>
                                                        </div>

                                                    </td>
                                                    <td style={{


                                                    }}>{item?.category}</td>
                                                    <td style={{


                                                    }}>
                                                        {item?.sub_category != null ? item?.sub_category : '--'}
                                                    </td>
                                                    {/* <td>{item?.referred_by != [] ? item?.referred_by?.user_referral_code : ''}</td> */}
                                                    <td style={{


                                                    }}>{item?.subscription_name}</td>
                                                    <td style={{
                                                        padding: 0,
                                                        margin: 0,
                                                        textAlign: 'center'
                                                    }}>{item?.amount}</td>
                                                    <td className='address-td text_view' style={{


                                                    }}>
                                                        {item?.date !== null ? moment(item?.date).format('DD-MM-YYYY') : '--'}
                                                    </td>
                                                    <td className='joing-date' style={{

                                                        padding: 0,
                                                        margin: 0
                                                    }}>
                                                        <p style={{
                                                            padding: 0,
                                                            margin: 0
                                                        }}>
                                                            {moment(item?.approved_date).format('DD-MM-YYYY')}

                                                        </p>

                                                    </td>
                                                    <td style={{


                                                    }}>
                                                        <div>
                                                            <p
                                                                style={{
                                                                    color: item?.current_profile_status == 'Live' ? 'green' : 'red'
                                                                }}
                                                            > {item?.current_profile_status}</p>
                                                            <p style={{
                                                                cursor: 'pointer',
                                                                backgroundColor: '#000000',
                                                                fontSize: 11,
                                                                color: '#fff',
                                                                textAlign: 'center'
                                                            }}
                                                                onClick={() => {
                                                                    setCurrentmemberdetails(item)
                                                                    getRevenueList(item?.id)
                                                                }}

                                                                // class="fa fa-eye"
                                                                data-bs-toggle="offcanvas" data-bs-target="#offcanvasRight" aria-controls="offcanvasRight"
                                                                aria-hidden="true"
                                                            >
                                                                {
                                                                    item?.renue_profile_count > 0 && `Renue: ${item?.renue_profile_count}`
                                                                }
                                                            </p>
                                                            <p style={{
                                                                color: item?.current_profile_status == 'Live' ? 'black' : 'red'
                                                            }}>
                                                                {
                                                                    item?.current_profile_status == 'Live' && `Expire on ${moment(item?.expiry_date).format('DD-MM-YYYY')}`
                                                                }
                                                                {
                                                                    item?.current_profile_status == 'Expired' && `Expire ${moment(item?.expiry_date).format('DD-MM-YYYY')}`
                                                                }
                                                                {
                                                                   ( item?.current_profile_status == 'Renewal' && item?.expiry_status != 1) && `Expire on ${moment(item?.expiry_date).format('DD-MM-YYYY')}`
                                                                }
                                                                {
                                                                    (item?.current_profile_status == 'Renewal' && item?.expiry_status == 1) && `Expire ${moment(item?.expiry_date).format('DD-MM-YYYY')}`
                                                                }
                                                            </p>
                                                        </div>



                                                    </td>

                                                </tr>
                                            </>
                                        )
                                    })
                                }

                            </tbody>

                        </table>
                        <div className='nodata-found-div'>
                            {
                                memberlist?.length == 0 ?
                                    <p>No Data Found</p>
                                    //  <img 
                                    //  className='table-image'
                                    //  src={require('../../assets/OIP.png')}/>
                                    : null
                            }
                        </div>
                    </div>
                </div>
            </div>
            <div class="tablepgntn">
                <p>Show <select value={getLimit} onChange={(val) => {
                    setLimit(val.target.value)
                    setCurrentPage(1)
                    // setLimitChange(true)
                }}>
                    <option value={10}>10</option>
                    <option value={20}>20</option>
                    <option value={30}>30</option>
                    <option value={40}>40</option>
                    <option value={50}>50</option>
                </select> Entries</p>
                <ul>

                </ul>
                <Pagination
                    currentPage={currentPage}
                    totalPages={totalPages}
                    onPageChange={handlePageChange}
                />

            </div>

            {/* /// side bar */}

            <div
                style={{ width: '80vw', maxWidth: '50vw', height: '100vh' }}
                class="offcanvas offcanvas-end " tabindex="-1" id="offcanvasRight" aria-labelledby="offcanvasRightLabel">
                <div class="offcanvas-header">
                    <h5 class="offcanvas-title" id="offcanvasRightLabel">Details</h5>
                    <button type="button" class="btn-close" data-bs-dismiss="offcanvas" aria-label="Close"></button>

                </div>
                <div style={{
                    paddingLeft: 20
                }}>
                    <h6>User Name: {currentmemberdetails?.member_name}</h6>
                    <h6>Member ID: {currentmemberdetails?.member_code}</h6>
                </div>

                {
                    memberDetailsLoading ? (
                        <div style={{
                            display: 'flex',
                            justifyContent: 'center',
                            alignItems: 'center',
                            padding: 10
                        }}>

                            <span class="loader"></span>
                        </div>
                    ) :
                        (
                            <>
                                <div class="offcanvas-body">
                                    <div class="row">
                                        <div class="col-md-12">
                                            <div class="table-responsive">
                                                <table class="table">
                                                    <thead>
                                                        <tr>
                                                            <th>SL NO</th>
                                                            <th>Plan Name</th>
                                                            <th>Pay Amount</th>
                                                            <th>Renewed / Buying Date</th>
                                                            <th>Expiry Date</th>
                                                            {/* <th>Date</th>
                                                            <th>Up 1 Distribution	</th>
                                                            <th>Up 2 Distribution</th>
                                                            <th>Total Distribution</th>
                                                            <th>Net Profit(<i className="fa fa-inr" />)</th> */}


                                                        </tr>
                                                    </thead>
                                                    {
                                                        !memberDetailsLoading && (
                                                            <tbody>

                                                                {
                                                                    revenueList?.map((item, index) => {

                                                                        return (
                                                                            <tr>
                                                                                <td>
                                                                                    {index + 1}
                                                                                </td>
                                                                                <td>
                                                                                    {item?.plan_name}
                                                                                </td>
                                                                                <td>
                                                                                    {item?.price}
                                                                                </td>
                                                                                <td>
                                                                                    {moment(item?.start_date).format('DD-MM-YYYY')}
                                                                                </td>
                                                                                <td>
                                                                                    {moment(item?.expiry_date).format('DD-MM-YYYY')}
                                                                                </td>

                                                                            </tr>
                                                                            // <tr> </tr>
                                                                        )
                                                                    })
                                                                }

                                                            </tbody>
                                                        )
                                                    }

                                                </table>

                                            </div>
                                        </div>
                                    </div>

                                </div>
                            </>
                        )
                }

            </div>
        </div>
    )
}
const boxStyle = {
    width: '200px',
    height: '60px',
    background: '#bbb',
    margin: '20px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    borderRadius: '6px',
    cursor: 'pointer'
}
export default ApprovedProfile;